import { createEntityComboBox } from './helpers/createEntityComboBox';

import { createQueryHook } from '~/shared/providers/api';
import { QueryHookResult } from '~/shared/providers/api/createQueryHook';

export type SelectableInventoryTag = QueryHookResult<
  typeof useInventoryTagsQuery
>[number];

export const useInventoryTagsQuery = createQueryHook(
  'shared.selectInventoryTag',
  (params: {
    searchTerm?: string;
    ids?: string[];
    facilityId?: string;
    itemId?: string;
    lotId?: string;
    status?: 'Active' | 'Draft' | 'InInventory';
  }) => ({
    inventoryTags: {
      __args: {
        filter: {
          ids: params.ids,
          tagNumber: params.searchTerm,
          facilityId: params.facilityId,
          itemId: params.itemId,
          lotId: params.lotId,
          status: params.status,
        },
        pagination: {
          offset: 0,
          limit: !params.searchTerm || !params.itemId ? 50 : 1000,
        },
      },
      entries: {
        id: true,
        tagNumber: true,
        tagType: true,
        status: true,
        facilityId: true,
        itemId: true,
        item: {
          id: true,
          name: true,
          effectivePricingUnit: true,
          itemGroup: {
            id: true,
            name: true,
          },
        },
        lotId: true,
        grossQuantity: true,
        tare: true,
        netQuantity: true,
      },
    },
  }),
  {
    select: (data) => data.inventoryTags.entries ?? [],
  },
);

export const SelectInventoryTag = createEntityComboBox.remotelySearched(
  'SelectInventoryTag',
  useInventoryTagsQuery,
  {
    formatLabel: (entity) => entity.tagNumber,
    formatSubLabel: (entity) => {
      const parts: string[] = [];
      if (entity.item?.name) {
        parts.push(entity.item.name);
      }
      if (entity.netQuantity !== undefined) {
        parts.push(`${entity.netQuantity} lbs`);
      }
      return parts.join(' - ');
    },
  },
);
